import React from 'react';
import { NavLink } from 'react-router-dom';

export default function BottomNav() {
  const items = [
    { to: '/', label: 'Home', icon: '🏠' },
    { to: '/groups', label: 'Groups', icon: '👥' },
    { to: '/payments', label: 'Pay', icon: '💳' },
    { to: '/notifications', label: 'Notifications', icon: '🔔' },
    { to: '/bank-details', label: 'Banks', icon: '🏦' },
  ];

  return (
    <nav className="bottom-nav" role="navigation" aria-label="Bottom navigation">
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          className={({ isActive }) =>
            'bottom-nav__item' + (isActive ? ' is-active' : '')
          }
          end={it.to === '/'}
        >
          <div className="bottom-nav__icon" aria-hidden="true">{it.icon}</div>
          <div className="bottom-nav__label">{it.label}</div>
        </NavLink>
      ))}
    </nav>
  );
}
